/* Jedinstveno čitanje greške iz fetch lanca.

   Kroz `.catch` u ovom projektu prolaze DVE vrste grešaka:
     1. HTTP odgovor koji nije ok — `handleErrors` ga baci kao Response, pa ima
        `.json()`
     2. obična JS greška iz `.then` bloka (TypeError, JSON.parse i slično) —
        ona `.json()` NEMA

   Kod pisan kao `error.json().then(...)` radi samo za prvu. Kad naiđe druga,
   sam `.catch` pukne sa "error.json is not a function", pa se prava greška
   nikad ne vidi: nema ni poruke, ni zapisa u konzoli, a ekran ostane prazan.

   `uzmiGresku` vraća isto što je taj kod očekivao — promise sa objektom koji
   ima `message` — pa se poziv menja jedan u jedan:

       error.json().then((errorMessage) => { ... })
       uzmiGresku(error).then((errorMessage) => { ... })
*/
export const uzmiGresku = async (error, podrazumevana = 'Došlo je do greške.') => {
    if (typeof error?.json === 'function') {
        try {
            const telo = await error.json();
            if (telo && telo.message) return telo;
        } catch {
            /* odgovor nije JSON (HTML stranica greške, prazno telo) */
        }
        return { message: podrazumevana };
    }

    /* JS greška — u konzolu ide ceo objekat sa stack trace-om, jer je poruka
       sama po sebi retko dovoljna da se nađe uzrok. */
    console.error(error);
    return { message: error?.message || podrazumevana };
};

export default uzmiGresku;
